import styles from './NaviTablePagination.module.scss';
import { Pagination } from '@navi/web-ui/lib/components';
import { useNaviTableContext } from '../../context/NaviTableContext';
import { DropDownPosition } from '@navi/web-ui/lib/components/Pagination/constant';
import { RowData } from '@tanstack/react-table';
import { NaviTableVariants } from '../../interfaces';
import cx from 'classnames';

const NaviTablePagination = <TData extends RowData>() => {
  const {
    table,
    totalElements = 0,
    paginationClasses,
    variant = NaviTableVariants.DEFAULT
  } = useNaviTableContext<TData>();
  const handleOnPageSizeChange = (pageSize: number) => {
    table.setPagination({
      pageIndex: 0,
      pageSize
    });
  };

  const isCardVariant = variant === NaviTableVariants.CARDS;

  const handleOnPageChange = (pageIndex: number) => {
    table.setPageIndex(pageIndex - 1);
  };
  return (
    <div
      className={cx(
        styles.paginationContainer,
        {
          [styles.paginationCardVariant]: isCardVariant
        },
        paginationClasses
      )}
    >
      <Pagination
        totalCount={totalElements}
        onPageChange={handleOnPageChange}
        currentPage={table.getState().pagination.pageIndex + 1}
        onPageSizeChange={handleOnPageSizeChange}
        pageSize={table.getState().pagination.pageSize}
        pageNumberDropDownPosition={DropDownPosition.TOP}
        containerClasses={styles.pagination}
      />
    </div>
  );
};

export default NaviTablePagination;
